import { Link } from "react-router-dom";
import VerdictBadge from "@/components/feature/VerdictBadge";
import { articles } from "@/mocks/articles";

export default function ReversalRanking() {
  const ranked = articles
    .filter((a) => a.verdict === "出现反转" || a.verdict === "打脸现场")
    .sort((a, b) => b.heat - a.heat);

  const list = articles
    .filter((a) => a.verdict === "已辟谣" || a.verdict === "已证实")
    .slice(0, 4);

  return (
    <section className="w-full">
      <div className="mb-8">
        <h2 className="font-heading text-2xl font-700 text-foreground-950 md:text-3xl">反转与打脸榜</h2>
        <p className="mt-2 text-sm text-foreground-600">曾经言之凿凿、后来被证据推翻的那些料，按关注度排列。</p>
      </div>

      <div className="grid gap-6 lg:grid-cols-5">
        <div className="col-span-1 overflow-hidden rounded-lg border border-accent-200 bg-accent-50 lg:col-span-3">
          {ranked.map((a, idx) => (
            <Link
              key={a.id}
              to={`/article/${a.id}`}
              className={`flex items-center gap-4 px-4 py-4 transition-colors hover:bg-accent-100 md:px-6 md:py-5 ${
                idx !== ranked.length - 1 ? "border-b border-accent-200" : ""
              }`}
            >
              <span className="font-label text-3xl font-600 text-accent-500/70">{idx + 1}</span>
              <div className="flex min-w-0 flex-1 flex-col gap-2">
                <div className="flex flex-wrap items-center gap-2">
                  <VerdictBadge verdict={a.verdict} />
                  <span className="text-xs text-accent-800/70">{a.category}</span>
                </div>
                <h3 className="line-clamp-2 font-heading text-sm font-600 leading-snug text-foreground-950 md:text-base">
                  {a.title}
                </h3>
              </div>
              <i className="ri-arrow-right-up-line hidden shrink-0 text-xl text-accent-600 sm:block"></i>
            </Link>
          ))}
        </div>

        <div className="col-span-1 rounded-lg border border-background-200 bg-background-50 p-5 lg:col-span-2">
          <h3 className="flex items-center gap-2 font-heading text-base font-600 text-foreground-950">
            <i className="ri-shield-check-line text-secondary-600"></i>
            已定型结论
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            证据链完整、结论明确的条目，包含官方通报与权威回应。
          </p>
          <ul className="mt-4 space-y-3">
            {list.map((a) => (
              <li key={a.id}>
                <Link to={`/article/${a.id}`} className="group flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-secondary-500"></i>
                  <span className="line-clamp-2 text-sm leading-snug text-foreground-700 transition-colors group-hover:text-secondary-700">
                    {a.title}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}